module.exports = __webpack_public_path__ + "static/media/Cabinet2_Before.965af3dd.jpg";